import React, { SyntheticEvent, useEffect, useRef } from 'react';

import styles from './HorizontalScroll.module.scss';

type HorizontalScrollProps = {
	scroll: number;
	svgWidth: number;
	taskListWidth: number;
	onScroll: (event: SyntheticEvent<HTMLDivElement>) => void;
}

const HorizontalScroll: React.FC<HorizontalScrollProps> = ({
	scroll,
	svgWidth,
	taskListWidth,
	onScroll,
}) => {
	const scrollRef = useRef<HTMLDivElement>(null);

	useEffect(() => {
		if (scrollRef.current) {
			scrollRef.current.scrollLeft = scroll;
		}
	}, [scroll]);

	return (
		<div
			ref={scrollRef}
			className={styles.scrollWrapper}
			dir='ltr'
			onScroll={onScroll}
			style={{
				margin: `0px 0px 0px ${taskListWidth}px`,
			}}
		>
			<div
				className={styles.scroll}
				style={{ width: svgWidth }}
			/>
		</div>
	);
};

export default HorizontalScroll;
